import _omit from 'lodash/omit';
import { FieldItem } from '@lib/interfaces/form';

// FieldItem keys that configure a `subFields` array. They are renamed for
// <FieldArray> and must not leak onto a plain <FormItem>.
export const FIELD_ARRAY_ONLY_KEYS = [
  'fieldComponents',
  'isDraggable',
  'isSubItemDraggableFn',
  'isSubItemRemovableFn',
  'subFieldEmptyStateText',
  'subFieldEmptyStateTitle',
  'subFieldTitle',
  'subFieldsAddMoreButtonText',
  'subFieldsEntity',
  'subFieldsMaxLength',
  'subFieldsMaxLengthTooltipProps',
  'subFieldsMinLength',
] as const;

/**
 * Maps a `subFields` FieldItem onto <FieldArray> props. Shared by top-level
 * arrays (getFormData) and nested arrays (FieldArrayItem) so both get the
 * same `subFields*` → `entity` / `title` / `emptyState*` renames.
 */
export default function getFieldArrayProps(
  field: FieldItem,
  parentName: string = field.name,
) {
  const {
    subFieldEmptyStateText,
    subFieldEmptyStateTitle,
    subFieldTitle,
    subFields = [],
    subFieldsEntity,
  } = field;
  return {
    ..._omit(field, [
      'name',
      'validation',
      'subFieldEmptyStateText',
      'subFieldEmptyStateTitle',
      'subFieldTitle',
      'subFieldsEntity',
    ]),
    emptyStateText: subFieldEmptyStateText,
    emptyStateTitle: subFieldEmptyStateTitle,
    entity: subFieldsEntity,
    parentName,
    subFields,
    title: subFieldTitle,
  };
}
